export default __webpack_public_path__ + "static/media/discordia.87103b7f.png";